import { Link } from "@tanstack/react-router";
import { differenceInDays, formatDistance } from "date-fns";
import { Trans } from "react-i18next";

import { useUser } from "~/hooks/use-user";
import { cn } from "~/lib/utils";

function TrialEnded() {
  return (
    <p>
      <Trans
        key="trial_ended"
        i18nKey="trial_ended_banner"
        components={{
          upgradeLink: (
            <Link
              to="/settings/account/contracts"
              className="font-bold underline"
            />
          ),
        }}
      />
    </p>
  );
}

function TrialEnding({ trialEndDate }: { trialEndDate: Date }) {
  const daysLeft = differenceInDays(trialEndDate, new Date());
  console.log(daysLeft);
  return (
    <p>
      <Trans
        i18nKey="trial_ending_banner"
        components={{
          trialEndDate: (
            <span
              className={cn(
                daysLeft <= 5 && "text-orange-500",
                daysLeft < 3 && "text-red-500 font-bold",
              )}
            />
          ),
          upgradeLink: (
            <Link
              to="/settings/account/contracts"
              className="font-bold underline"
            />
          ),
        }}
        values={{
          trial_end_date: formatDistance(trialEndDate, new Date(), {
            addSuffix: true,
          }),
        }}
      />
    </p>
  );
}

export default function TrialEndBanner() {
  const { user } = useUser();
  const trialEndDate = user.subscription?.trialEndAt;

  if (!trialEndDate) {
    return null;
  }

  const daysLeft = Math.round(
    (trialEndDate.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24),
  );

  if (daysLeft > 10) {
    return null;
  }

  return (
    <div className="p-2 flex items-center justify-center border-b">
      {daysLeft <= 0 ? (
        <TrialEnded />
      ) : (
        <TrialEnding trialEndDate={trialEndDate} />
      )}
    </div>
  );
}
